__turbopack_context__.v({
  "calloutSection": "PlasmicCalloutSection-module__v6gpqa__calloutSection",
  "calloutSectionTextColumn__kgZpF": "PlasmicCalloutSection-module__v6gpqa__calloutSectionTextColumn__kgZpF",
  "calloutSectionTextColumn__mGMnL": "PlasmicCalloutSection-module__v6gpqa__calloutSectionTextColumn__mGMnL",
  "calloutSectionTextColumn__wxx4L": "PlasmicCalloutSection-module__v6gpqa__calloutSectionTextColumn__wxx4L",
  "desktop": "PlasmicCalloutSection-module__v6gpqa__desktop",
  "mobile": "PlasmicCalloutSection-module__v6gpqa__mobile",
  "tablet": "PlasmicCalloutSection-module__v6gpqa__tablet",
  "wrapper": "PlasmicCalloutSection-module__v6gpqa__wrapper",
  "wrapper3": "PlasmicCalloutSection-module__v6gpqa__wrapper3",
  "wrapper4": "PlasmicCalloutSection-module__v6gpqa__wrapper4",
});
